export var DEFAULT_LABELKEY = 'label';
export var Size;

(function (Size) {
  Size["LARGE"] = "large";
  Size["LG"] = "lg";
  Size["SM"] = "sm";
  Size["SMALL"] = "small";
})(Size || (Size = {}));